import ColumnText from "../molecules/ColumnText";
import { Fragment } from "react";
import { Empty } from "./Empty";

type optionsKPISProps = {
  id: number;
  name: string;
  image: string;
  servicesScheduled: string;
  servicesCompleted: string;
};

export type TableListKPISProps = {
  optionsKPIS: optionsKPISProps[];
};

const TableListKPIS: React.FC<TableListKPISProps> = ({ optionsKPIS }) => {
  return (
    <div className="">
      <div className="border-b border-gray-300 mt-5"></div>
      <div className="flow-root">
        {/* Añadir un contenedor con scroll */}
        <div className="overflow-x-auto max-h-[60vh]">
          <div className="inline-block min-w-full align-middle">
            {optionsKPIS.length === 0 ? (
              <Empty texto="No hay KPIS" />
            ) : (
              <Fragment>
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Especialista
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Servicios profesionales agendados
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Servicios profesionales completados
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {optionsKPIS.map((option) => (
                      <tr key={option.id}>
                        <ColumnText title={option.name} />
                        <ColumnText title={option.servicesScheduled} />
                        <ColumnText title={option.servicesCompleted} />
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableListKPIS;
